import { createFileRoute } from '@tanstack/react-router'
import { SessionPlayerPage } from '#pages/client/SessionPlayerPage'

export const Route = createFileRoute('/_app/session/$sessionId')({
  component: SessionPlayerPage,
})
